import { ComparablesFilterFields } from "../components/Filters/FiltersWithClear";
import { hiddenFieldsByFeature } from "./hiddenFields";

export function getCombinedDisabledFields(disabledFields: Set<ComparablesFilterFields>): Set<ComparablesFilterFields> {
  const featureHiddenFields = hiddenFieldsByFeature.reduce((set, [hideCheck, fields]) => {
    if (hideCheck()) {
      return new Set([...set, ...fields]);
    }
    return set;
  }, new Set<ComparablesFilterFields>());

  return new Set([...disabledFields, ...featureHiddenFields]);
}
